import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, map, pairwise } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RoutingService {
    
    private previousUrl: string = '';
    private currentUrl: string = '';

    constructor(private router: Router, private currentRoute: ActivatedRoute) {

        this.currentUrl = this.router.url;

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            pairwise()
        ).subscribe((events: NavigationEnd[]) => {
            this.previousUrl = events[0].urlAfterRedirects;
            this.currentUrl = events[1].urlAfterRedirects;
        });
    }

    getCurrentUrl(): Observable<NavigationEnd> {
        return this.router.events.pipe(filter(event => event instanceof NavigationEnd), map((event: NavigationEnd) => event));
    }

    getCurrentUrlName(): Observable<string> {
        return this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => this.router.url)
        );
    }

    public getPreviousUrl(): string {
        return this.previousUrl;
    }
}
